<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-list-alt"></i>
          サイト
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WMDS</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">サイト</a>
          </li>
      </ul>
    </div>
    <quick-setup @refresh="refresh" v-if="is_first" @count="x => this.$parent.$emit('count', x)"></quick-setup>
    <b-tabs v-else v-model="tab_index">
      <b-tab no-body title="サイト">
        <b-row>
          <b-col lg="12" :xl="isLoadPolicy ? 8 : 12">
            <b-card>
              <div slot="header">
                <strong>サイト情報</strong>
                <span v-if="!add && model.created_at">( 登録済み : {{model.created_at | sdate}})</span>
                <span class="float-right" v-if="!add && model.last_visit">最終訪問日 : {{model.last_visit | sdate}}</span>
                <span class="float-right" v-else> - </span>
              </div>
              <b-row>
                <b-col md="2" v-if="add" style="cursor:pointer">
                  <b-form-group>
                    <label v-b-tooltip.hover title="サイト登録を開始して確認する">
                      登録時に開始
                      <span class="text-info">
                        <i style="cursor:pointer" class="fas fa-question-circle"></i>
                      </span>
                    </label>
                    <br>
                    <c-switch color="info" label size="sm" v-model="model.is_start" :disabled="lock" />
                  </b-form-group>
                </b-col>
                <b-col md="2" v-else>
                  <b-form-group>
                    <label v-b-tooltip.hover title="スキャンの有効化または無効化を設定する">
                      有効
                      <span class="text-info">
                        <i style="cursor:pointer" class="fas fa-question-circle"></i>
                      </span>
                    </label>
                    <br>
                    <c-switch color="info" label size="sm" v-model="model.is_alive" :disabled="lock" />
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-form-group>
                    <label v-b-tooltip.hover title="jsクリックイベントトリガーの切り替え">
                      JSイベント
                      <span class="text-info">
                        <i style="cursor:pointer" class="fas fa-question-circle"></i>
                      </span>
                    </label>
                    <br>
                    <c-switch color="info" label size="sm" v-model="model.is_js" :disabled="lock" />
                  </b-form-group>
                </b-col>
                <b-col md="3">
                  <b-form-group>
                  <label v-b-tooltip.hover title="ログインの有効または無効を設定する">
                    ログインの有効化
                    <span class="text-info">
                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                  </label>
                  <br>
                    <c-switch color="info" label size="sm" v-model="model.is_login" :disabled="lock" />
                  </b-form-group>
                </b-col>
                <b-col md="5" v-show="!add && lock">
                  <b-form-group>
                    <label v-b-tooltip.hover title="チェックポリシーを指定します。ポリシーは事前に生成されている必要があります">
                      ポリシーの確認
                      <span class="text-info">
                        <i style="cursor:pointer" class="fas fa-question-circle"></i>
                      </span>
                    </label>
                    <p>{{policy.description}}</p>
                  </b-form-group>
                </b-col>
                <b-col md="6" v-show="!lock">
                  <b-form-group>
                    <label for="ph_schedule_type" v-b-tooltip.hover title="チェックポリシーを指定します。ポリシーは事前に生成されている必要があります">
                      ポリシーの確認
                      <span class="text-info">
                        <i style="cursor:pointer" class="fas fa-question-circle"></i>
                      </span>
                    </label>
                    <b-form-select v-model="model.policy_id" @change="change($event)" :disabled="lock" ref="policy">
                      <option v-for="item in policy_list" :key="item.id" :value="item.id">{{item.description ? item.description : item.policy.description}}</option>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-group>
                    <label for="ph_username" v-b-tooltip.hover title="サイトを区切る名前を指定します">
                      名前
                      <span class="text-info">
                        <i style="cursor:pointer" class="fas fa-question-circle"></i>
                      </span>
                    </label>
                    <b-form-input placeholder="FQDN入力時の自動入力" type="text" id="ph_name" v-model="model.name" :plaintext="lock"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <hr>
              <b-row>
                <b-col md="12">
                  <b-form-group>
                    FQDN : ex) www.f1security.co.kr : www(host) + f1security.co.kr(domain)
                    <hr>
                    <b-input-group class="text-center">
                      <b-input-group-prepend><b-input-group-text> FQDN </b-input-group-text></b-input-group-prepend>
                      <b-form-input class="text-center border" type="text" ref="fqdn" id="ph_fqdn" placeholder="FQDN (例 : www.company.com)" v-model="model.fqdn" :plaintext="lock" @change="check_fqdn"></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <hr>
              <b-row>
                <b-col md="12">
                  <label
                    style="cursor:pointer"
                    v-b-tooltip.hover.hover:title="`チェックするURLまたはチェックするメインページまたはチェックするページのURL`"
                  >
                    チェック開始URL（最大10件
                    <span class="text-info">
                      <i class="fas fa-question-circle"></i>
                    </span>
                  </label>
                  <b-form-group>
                    <b-input-group>
                      <b-input-group-prepend><b-input-group-text> 始まり </b-input-group-text></b-input-group-prepend>
                      <b-form-input id="ph_seed" v-model="v.seed" type="url" placeholder="Full URL, 例) https://f1security.co.kr" @keyup.native.enter="add_seed()" :disabled="lock || (model.config.seeds.length >= 10)"></b-form-input>
                      <b-input-group-append>
                        <b-button class="btn-addition" variant="primary" @click="add_seed()" :disabled="lock || (model.config.seeds.length >= 10)">追加</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                  <b-form-group>
                    <b-list-group>
                      <b-list-group-item v-for="(seed, index) in model.config.seeds" :key="'_seed_'+index"><i class="fa fa-times" @click="remove_seed(seed)" v-show="!lock"></i> {{seed}}</b-list-group-item>
                    </b-list-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <hr>
              <b-row>
                <b-col md="12">
                  <b-form-group>
                    <label
                      v-b-tooltip.hover.hover:title="`検査周期を設定します。サイトにアクセスする人が少ない時間帯に少なくとも 1 日に 1 回検査することをお勧めします。`"
                      style="cursor:pointer"
                    >
                      スケジュールの確認
                      <span class="text-info">
                        <i class="fa fa-question-circle"></i>
                      </span>
                    </label>
                    <small>最大 :{{max_schedule}}</small>
                    <hr>
                    * <b-badge variant="warning">お知らせ</b-badge>
                    : サイトの利用やオーバーチェックは、1日24回までと制限できます
                    <hr>
                    <b-input-group>
                      <!-- <b-form-select ref="schedule" id="ph_schedule" v-model="s.h" :options="s.h_opt" :disabled="lock" @change="schedule($event, 'h')"></b-form-select>
                      <b-form-select v-model="s.m" :options="s.m_opt" :disabled="lock" @change="schedule($event, 'm')"></b-form-select> -->
                      <b-form-select v-if="i18n" ref="schedule" id="ph_schedule" v-model="s.h" :options="s.h_opt[i18n]" :disabled="lock" @change="schedule($event, 'h')"></b-form-select>
                      <b-form-select v-if="i18n" v-model="s.m" :options="s.m_opt[i18n]" :disabled="lock" @change="schedule($event, 'm')"></b-form-select>
                      <b-input-group-append>
                        <b-button class="btn-addition" variant="primary" @click="add_schedule" :disabled="lock || (model.schedule.length >= max_schedule)">追加</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-group>
                    <b-list-group>
                      <b-list-group-item v-for="(schedule, index) in model.schedule" :key="'_sch_'+index">
                        <i class="fa fa-times" @click="remove_schedule(schedule)" v-if="!lock"></i>
                        ({{ schedule }}) {{ cron_filter(schedule) }}
                      </b-list-group-item>
                    </b-list-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <hr>
              <strong>追加情報</strong>
              <hr>
              <b-row>
                <b-col md="6">
                  <b-form-group>
                    <label
                      style="cursor:pointer"
                      for="ph_sub_domain"
                      v-b-tooltip.hover.hover title="同一サイト内にサブドメインが存在する場合に登録 例) admin.f1security.co.kr"
                    >
                      サブドメイン
                      <span class="text-info">
                        <i class="fas fa-question-circle"></i>
                      </span>
                    </label>
                    <b-input-group>
                      <b-form-input id="ph_sub_domain" v-model="v.sub" type="text" ref="sub_domains" placeholder="ドメイン" @keyup.native.enter="add_sub" :disabled="lock || (model.config.subs.length >= 100)"></b-form-input>
                      <b-button class="btn-addition" variant="primary" @click="add_sub" :disabled="lock || (model.config.subs.length >= 100)">追加</b-button>
                    </b-input-group>
                  </b-form-group>
                  <b-form-group>
                    <b-list-group>
                      <b-list-group-item v-for="(sub, index) in model.config.subs" :key="'_sub_'+index"><i style="cursor:pointer" class="fa fa-times" v-show="!lock" @click="remove_sub(sub)"></i> {{sub}}</b-list-group-item>
                    </b-list-group>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group>
                    <label
                      style="cursor:pointer"
                      for="ph_prevent"
                      v-b-tooltip.hover.hover title="例外を処理するパスを指定します(部分が一致しない) 例) /admin/download">
                      例外パス
                      <span class="text-info">
                        <i class="fas fa-question-circle"></i>
                      </span>
                    </label>
                    <b-input-group>
                      <b-form-input id="ph_prevent" v-model="v.prevent" ref="prevent" type="text" placeholder="サブルーチンパス" @keyup.native.enter="add_prevent" :disabled="lock || (model.config.prevenlength >= 100)"></b-form-input>
                      <b-input-group-append>
                        <b-button class="btn-addition" variant="primary" @click="add_prevent" :disabled="lock || (model.config.prevenlength >= 100)">追加</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                  <b-form-group>
                    <b-list-group>
                      <b-list-group-item v-for="(prevent, index) in model.config.prevents" :key="'_prevent_'+index"><i style="cursor:pointer" class="fa fa-times" v-show="!lock" @click="remove_prevent(prevent)"></i> {{prevent}}</b-list-group-item>
                    </b-list-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-group>
                    <label
                      style="cursor:pointer"
                      for="ph_prevent"
                      v-b-tooltip.hover.hover title="例外として扱う単語を正規表現で入力(部分一致可) 例) (編集|削除)">
                      例外の正規表現
                      <span class="text-info">
                        <i class="fas fa-question-circle"></i>
                      </span>
                    </label>
                    <b-form-input class="text-center border" v-model="model.regex" placeholder="正規表現形式をサポート" :disabled="lock"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <!-- <hr>
              <template v-if="lock">
                <template v-if="model.is_del">
                  <b-button size="sm" variant="success" @click="revive"> リカバー </b-button>
                  <span>リカバー</span>
                </template>
                <template v-else>
                  <b-button size="sm" variant="primary" @click="edit" class="btn-add"> 編集 </b-button>
                  <b-button size="sm" variant="danger" @click="del_confirm = true"> 削除 </b-button>
                </template>
              </template>
              <template v-else>
                <b-button size="sm" variant="success" @click="() => model.id ? save() : modal_charge_agree = true"> 保存 </b-button>
                <b-button size="sm" variant="default" @click="cancel" class="btn-cancel"> キャンセル </b-button>
              </template>
              <b-button size="sm" class="float-right text-white" variant="secondary" @click="list"> 一覧 </b-button>  -->
            </b-card>
          </b-col>
          <!-- </b-row> -->
          <!-- </b-col> -->
          <!-- policy start -->
          <b-col lg="12" xl="4" v-if="isLoadPolicy">
            <b-card>
              <div slot="header">
                <strong>ポリシー</strong>
                <small class="float-right">情報読み取り専用</small>
              </div>
              <b-row class="text-center">
                <b-col md="12">
                  <span block class="h5">{{ isLoadPolicy ?  policy.description : '-'}}</span>
                  <hr>
                  <small>
                    このページは、ポリシー情報のみを表示し、ポリシー編集ページで変更することができます。
                  </small>
                </b-col>
              </b-row>
              <hr>
              <b-row>
                <b-col md="12">
                  <b-form-group v-b-tooltip.hover.hover :title="`最初のページから次のページへリンクを移動（パス）して確認するかどうかを入力します。 クイックセットアップのデフォルト値は次のとおりです ${policy.depth}`">
                    <b-input-group-prepend><b-input-group-text> 最大パス深度 &nbsp;
                      <span class="text-info">
                        <i style="cursor:pointer" class="fas fa-question-circle"></i>
                      </span> </b-input-group-text></b-input-group-prepend>
                    <b-form-input :disabled="true" class="text-center border" type="number" id="ph_depth" :min="1" :max="100" v-model="policy.depth" :plaintext="true"></b-form-input>
                </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-group
                    v-b-tooltip.hover.hover
                    :title="`
                    ページ内を移動するためのサブリンクの最大数を入力します。
                    余分なリンクは無視してください。
                    通常、1 つのページに存在するリンクが多すぎる場合は、バランスの取れた方法でチェックされないことを防ぐために、他のページに移動する前に最大ナビゲーション ページに到達することができます。
                    クイックセットアップのデフォルト値は次のとおりです ${policy.links}`"
                  >
                      <b-input-group-prepend><b-input-group-text> サブページリンク &nbsp;
                        <span class="text-info">
                          <i style="cursor:pointer" class="fas fa-question-circle"></i>
                        </span> </b-input-group-text></b-input-group-prepend>
                      <b-form-input :disabled="true" class="text-center border" type="number" id="ph_links" :min="1" :max="1000" v-model="policy.links" :plaintext="true"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-group
                    v-b-tooltip.hover.hover
                    :title="`
                    検査サイトで確認する総ページ数。
                    入力した数値に達したらチェックを終了します。
                    1からライセンス制限までの範囲で指定できます。
                    クイックセットアップのデフォルト値は次のとおりです ${policy.limit}`"
                  >
                      <b-input-group-prepend><b-input-group-text> 最大ナビゲーションページ &nbsp;
                        <span class="text-info">
                          <i style="cursor:pointer" class="fas fa-question-circle"></i>
                        </span> </b-input-group-text></b-input-group-prepend>
                      <b-form-input :disabled="true" class="text-center border" type="number" id="ph_limit" :min="10" :max="50000" v-model="policy.limit" :plaintext="true"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-group
                    v-b-tooltip.hover.hover
                    :title="`
                    ページの読み込みを待つ時間。
                    1～30の範囲で指定できます。
                    クイックセットアップのデフォルト値は次のとおりです ${policy.timeout}`"
                  >
                      <b-input-group-prepend><b-input-group-text> タイムアウト(秒) &nbsp;
                        <span class="text-info">
                          <i style="cursor:pointer" class="fas fa-question-circle"></i>
                        </span> </b-input-group-text></b-input-group-prepend>
                      <b-form-input :disabled="true" class="text-center border" type="number" id="ph_timeout" :min="1" :max="30" v-model="policy.timeout" :plaintext="true"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-group
                    v-b-tooltip.hover.hover
                    :title="`
                   	新しいページに移動するまでの待ち時間。
                    1～10000の範囲で指定できます。
                    クイックセットアップのデフォルト値は次のとおりです ${policy.delay}`"
                  >
                      <b-input-group-prepend><b-input-group-text> チェック速度(ミリ秒) &nbsp;
                        <span class="text-info">
                          <i style="cursor:pointer" class="fas fa-question-circle"></i>
                        </span> </b-input-group-text></b-input-group-prepend>
                      <b-form-input :disabled="true" class="text-center border" type="number" id="ph_links" :min="0" :max="10000" v-model="policy.delay" :plaintext="true"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <hr>
              <template>
                <b-button class="btn-add" block size="sm" variant="success" @click="policy_manage"> 管理 </b-button>
              </template>
            </b-card>
            <!-- result start -->
            <b-card>
              <div slot="header" class="text-center">
                <strong v-if="result.page_count > 0">最新の検査結果があります。</strong>
                <strong v-else>最新のチェック履歴がありません。 </strong>
              </div>
              <template>
                <b-button :disabled="!(result.page_count > 0)" block size="sm" variant="warning" @click="confirm_result = true"> 確認 </b-button>
              </template>
            </b-card>
          </b-col>
        </b-row>
        <hr>
        <template v-if="lock">
          <template v-if="model.is_del">
            <b-button class="btn-add" size="sm" variant="success" @click="revive"> リカバー </b-button>
            <span>リカバー</span>
          </template>
          <template v-else>
            <b-button size="sm" variant="primary" @click="edit" class="btn-add"> 編集 </b-button>
            <b-button size="sm" variant="danger" @click="del_confirm = true"> 削除 </b-button>
          </template>
        </template>
        <template v-else>
          <b-button class="btn-add" size="sm" variant="success" @click="() => model.id ? save() : modal_charge_agree = true"> 保存 </b-button>
          <b-button size="sm" variant="default" @click="cancel" class="btn-cancel"> キャンセル </b-button>
        </template>
        <b-button size="sm" class="float-right text-white" variant="secondary" @click="list"> 一覧 </b-button>
      </b-card>
    </b-tab>
    <b-tab no-body title="ログインオプション" :disabled="!model.is_login">
      <vcl-facebook v-if="loading"></vcl-facebook>
      <b-card v-else>
        <template slot="header">
          <label v-b-tooltip.hover title="ログインが必要なページを確認する場合はアカウント情報を入力してください">
            <strong>WMDSログイン設定</strong>
            <span>
              <i style="cursor:pointer" class="fas fa-question-circle"></i>
            </span>
          </label>
        </template>
        <b-row>
          <b-col lg="11" xl="11">
            <b-form-group>
              <b-input-group class="text-center">
                <b-input-group-prepend><b-input-group-text> ログインページ </b-input-group-text></b-input-group-prepend>
                <b-form-input autocomplete="new-password" :disabled="lock" class="text-center border" type="text" ref="login_url" id="login_url" placeholder="ログイン URL : 例) http://www.f1security.co.kr/login.do" v-model="model.login_url" :plaintext="lock" @change="check_login"></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="iframe" v-b-tooltip.hover title="サイトは iframe を使用した構成">
              <c-switch color="info" label size="sm" v-model="opt_login.is_iframe" :disabled="lock" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <b-input-group class="text-center">
                <b-button class="m-2" size="sm" variant="primary" @click="test" :disabled="lock"> 1. ログインページのクロール機能 </b-button>
                  <p class="m-2">(</p>
                  <b-button class="m-2" size="sm" variant="primary" @click="popup(0)" :disabled="lock"> 2. 負荷のかかるjavascript、cssによる情報収集 </b-button>
                  <p class="m-2">or</p>
                  <b-button class="m-2" size="sm" variant="primary" @click="popup(1)" :disabled="lock"> 2. 負荷のかかるjavascript、cssによる情報収集 </b-button>
                  <p class="m-2">)</p>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col>
            <span class="text-danger">* ログイン機能で確認する場合は、上記の例外パスを追加して機能を回避します（削除、追加など）</span>
            <br>
            <span class="text-danger">* ログイン情報の収集が正常に完了しない場合は、手動で入力してください</span>
            <br>
            <span class="text-danger">* 新規にアカウント情報を収集する場合は、初期化を推奨します</span>
            <hr>
            <strong>
              サポートメッセージ : {{ !lock ? (opt_login_msg || '-') : '-' }}
            </strong>
          </b-col>
          <b-col>
            <b-row>
              <b-col>
                <b-button block class="m-2" size="sm" variant="warning" @click="() => { opt_login.username = ''; opt_login.password = ''; opt_login.el_password = ''; opt_login.el_username = ''; opt_login.el_submit = ''; }" :disabled="lock"> リセット </b-button>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col>
                <b-form-group class="text-center">
                  <b-input-group-prepend>
                    <b-input-group-text> ユーザー名のユニークな文字列 </b-input-group-text></b-input-group-prepend>
                  <b-form-input autocomplete="new-password" :disabled="lock" class="text-center border" type="text" v-model="opt_login.el_username" :state="(opt_login.el_username.length ? true : false)"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group class="text-center">
                  <b-input-group-prepend><b-input-group-text> ユーザー名の値 </b-input-group-text></b-input-group-prepend>
                  <b-form-input autocomplete="new-password" :disabled="lock" class="text-center border" type="text" v-model="opt_login.username" :state="(opt_login.username.length ? true : false)"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group class="text-center">
                  <b-input-group-prepend><b-input-group-text> パスワードのユニークな文字列 </b-input-group-text></b-input-group-prepend>
                  <b-form-input autocomplete="new-password" :disabled="lock" class="text-center border" type="text" v-model="opt_login.el_password" :state="(opt_login.el_password.length ? true : false)"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group>
                  <b-input-group-prepend style="display:inline-block;text-align:left; float:left;">
                    <b-input-group-text> パスワードの値 </b-input-group-text>
                  </b-input-group-prepend>
                  <b-input-group-prepend style="display:inline-block;text-align:right;float:right;">
                    <b-checkbox :disabled="lock" class="float-right" v-model="opt_login.is_show">表示</b-checkbox>
                  </b-input-group-prepend>
                  <b-form-input autocomplete="new-password" :disabled="lock" class="text-center border" :type="opt_login.is_show ? 'text' : 'password'" v-model="opt_login.password" :state="(opt_login.password.length ? true : false)"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group class="text-center">
                  <b-input-group-prepend><b-input-group-text> ログインボタンのユニークな文字列 </b-input-group-text></b-input-group-prepend>
                  <b-form-input autocomplete="new-password" :disabled="lock" class="text-center border" type="text" v-model="opt_login.el_submit" :state="(opt_login.el_submit.length ? true : false)"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card>
      <hr>
      <template v-if="lock && !loading">
        <template v-if="model.is_del">
          <b-button class="btn-add" size="sm" variant="success" @click="revive"> リカバー </b-button>
          <span>リカバー</span>
        </template>
        <template v-else>
          <b-button size="sm" variant="primary" @click="edit" class="btn-add"> 編集 </b-button>
          <b-button size="sm" variant="danger" @click="del_confirm = true"> 削除 </b-button>
        </template>
      </template>
      <template v-if="!lock && !loading">
        <b-button class="btn-add" size="sm" variant="success" @click="() => model.id ? save() : modal_charge_agree = true"> 保存 </b-button>
        <b-button size="sm" variant="default" @click="cancel" class="btn-cancel"> キャンセル </b-button>
      </template>
      <b-button v-if="!loading" size="sm" class="float-right text-white" variant="secondary" @click="list"> 一覧 </b-button>
    </b-tab>
  </b-tabs>
    <!-- delete modal -->
    <b-modal title="削除"  class="modal-danger" v-model="del_confirm" @ok="remove" @cancel="del_nickname = '';" header-bg-variant="danger" ok-variant="danger">
      <p> チェックのために登録したサイトを削除します </p>
      <p>
        削除された場合、悪意のあるコードの配布場所や停止状況を確認することはできません。
      </p>
      <p> 本当に削除しますか？ </p>
      <p> <b> * サイト名の確認 </b> </p>
      <p> サイト名の削除 : {{model.name}}  </p>
      <b-form-input v-model="del_nickname" placeholder="登録を解除するサーバーの名前を入力します。"></b-form-input>
    </b-modal>
    <!-- result modal -->
    <b-modal size="xl" title="サイトの結果"  class="modal-primary" v-model="confirm_result" hide-footer @ok="confirm_result = false" ok-variant="primary">
      <result :result_id="result.id" :site="model"></result>
    </b-modal>
    <!-- modal -->
    <b-modal size="xl" title="情報"  class="modal-info" v-model="modal_explain" hide-footer ok-variant="success">
      {{msg}}
    </b-modal>
    <b-modal v-model="modal_charge_agree" title="すべてのエージェントを制御" @ok="charge_agree" no-close-on-backdrop header-bg-variant="warning">
      <h5>最初のサイト登録が行われ、スキャンが開始された時点で課金が開始されます。</h5>
      <hr>
      <!-- <a target="_blank" :href="redir" class="card-link">
        <span class="text-dark">詳細を見る</span>
        <i class="fa fa-share"></i>
        {{redir}}
      </a> -->
      <hr>
      詳しくは規約をご覧ください。
      <h6> <b>本当によろしいですか？</b></h6>
    </b-modal>
    <b-modal v-model="opt_login.explain" title="ログインオプションの説明" @ok="opt_login.modal_explain = false" no-close-on-backdrop header-bg-variant="info">
      <h6>
        ログインが必要なサイトの場合、検査用アカウントを発行し、検査時にアカウントにログインしてログインが必要なサイトを確認します。
      </h6>
    </b-modal>
    <b-modal v-model="opt_login.modal_props" title="タグプロパティの一意の文字列を選択します" @ok="opt_login.modal_props = false" no-close-on-backdrop header-bg-variant="info" hide-footer>
      <h6>
        <b-form-group>

          <table class="table table-sm">
            <th>No.</th>
            <th>ユニークな文字列</th>
            <tr v-for="(item, index) in opt_login.props" :key="'_probs_'+index">
                <td> {{ index + 1 }} </td>
                <td>
                  <b-form-radio v-model="opt_login.sel_props" name="props" :value="item"> {{ item }} </b-form-radio>
                </td>
            </tr>
            <tr v-if="!opt_login.props">
              <td colspan="2"> 情報はありません </td>
            </tr>
          </table>
          <hr class="w-100">
          <b-button class="btn-add" block :disabled="!opt_login.props" size="sm" variant="success" @click="opt_login_select()"> 次へ </b-button>
        </b-form-group>
      </h6>
      <hr>
    </b-modal>
  </div>
</template>
<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
